import { useEffect, useRef } from 'react';
import { useOutletContext } from 'react-router-dom';
import type { FinancialAidStaffDetailContext } from '../ApplicantDetail';

export function CorrectionsTab() {
  const ctx = useOutletContext<FinancialAidStaffDetailContext>();
  const autoStartedRef = useRef(false);

  useEffect(() => {
    if (!ctx.isCorrectionEditing && !autoStartedRef.current) {
      autoStartedRef.current = true;
      ctx.beginCorrectionEditing();
    }
  }, [ctx.isCorrectionEditing, ctx.beginCorrectionEditing]);

  return (
    <div data-testid="financial-aid-corrections-tab" className="max-w-6xl space-y-4">
      <div>
        <h2 className="text-lg font-bold text-[#111827]">Corrections</h2>
      </div>
      {ctx.correctionEditor ?? (
        <button
          type="button"
          onClick={ctx.beginCorrectionEditing}
          className="inline-flex items-center justify-center rounded-lg bg-primary px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-primary-hover"
        >
          Start Correction
        </button>
      )}
    </div>
  );
}
